import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT = "alert-configs";

const currentUserPayload = () => ({
  currentUserId: store.state.currentUser?.uid,
});

const responseData = (response) => response.data.data;

const stripMeta = (data = {}) => {
  const { id, idDoc, ...payload } = data;
  return payload;
};

const AlertsConfigService = {
  getAlertsConfig: async () =>
    responseData(await apiService.get(ENDPOINT, {
      params: currentUserPayload(),
    })),

  createAlertConfig: async (data, links = {}) =>
    responseData(await apiService.post(ENDPOINT, {
      ...currentUserPayload(),
      ...stripMeta(data),
      ...links,
    })),

  editAlert: async (idDoc, data, links = {}) =>
    responseData(await apiService.put(`${ENDPOINT}/${encodeURIComponent(idDoc)}`, {
      ...currentUserPayload(),
      ...stripMeta(data),
      ...links,
    })),

  deleteAlertConfig: async (idDoc) =>
    responseData(await apiService.delete(`${ENDPOINT}/${encodeURIComponent(idDoc)}`, {
      data: currentUserPayload(),
    })),

  getSectorsByAlertConfig: async (idAlert) =>
    responseData(await apiService.get(`${ENDPOINT}/${encodeURIComponent(idAlert)}/sectors`, {
      params: currentUserPayload(),
    })),

  getUnitsByAlertConfig: async (idAlert) =>
    responseData(await apiService.get(`${ENDPOINT}/${encodeURIComponent(idAlert)}/units`, {
      params: currentUserPayload(),
    })),

  getAlertsIdsByUnitId: async (idUnit) =>
    responseData(await apiService.get(`${ENDPOINT}/units/${encodeURIComponent(idUnit)}/alert-ids`, {
      params: currentUserPayload(),
    })),

  getAlertsIdsBySectorsIds: async (sectorIds) =>
    responseData(await apiService.post(`${ENDPOINT}/sectors/alert-ids`, {
      ...currentUserPayload(),
      sectorIds,
    })),

  getListByAlertsIds: async (alertIds) =>
    responseData(await apiService.post(`${ENDPOINT}/by-ids`, {
      ...currentUserPayload(),
      alertIds,
    })),
};

export default AlertsConfigService;
